import type { CourseMetadata } from "@/types";

export const DEFAULT_LESSON_SEARCH_PLACEHOLDER = "Search lessons...";

export const GLOBAL_SEARCH_PLACEHOLDER_DESKTOP =
  "Search for courses and lessons";
export const GLOBAL_SEARCH_PLACEHOLDER_MOBILE = "Search courses & lessons";

export function lessonSearchPlaceholder(
  metadata?: CourseMetadata | string | null,
): string {
  const custom =
    typeof metadata === "string"
      ? metadata.trim()
      : metadata?.lesson_search_placeholder?.trim();
  return custom || DEFAULT_LESSON_SEARCH_PLACEHOLDER;
}
